import requests from "./api/base-api";

const TransactionService = {
    createTransaction: (body) => requests.post('/transaction/v1/request-transactions-charge-wallet', body),
    getAllTransActions:(body)=>requests.get('/transaction/v1/all-transaction-user', body),

    creditCodeChargeWallet:(body)=>requests.post('/creditcode/v1/redeem-creditcode', body),
}

export default TransactionService
